import { render, staticRenderFns } from "./TagGeneralTab.vue?vue&type=template&id=22e8a3cc"
import script from "./TagGeneralTab.vue?vue&type=script&lang=js"
export * from "./TagGeneralTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports